import { render, staticRenderFns } from "./ZibalCallback.vue?vue&type=template&id=14d397bc&scoped=true"
import script from "./ZibalCallback.vue?vue&type=script&lang=js"
export * from "./ZibalCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d397bc",
  null
  
)

export default component.exports